
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    //export class ProductsFranchiseeDialog extends Serenity.PropertyDialog<any, any> {
    export class CustomersSMSDialog extends Serenity.EntityDialog<CustomersRow, any> {
        protected getFormKey() { return CustomersSMSForm.formKey; }
        protected getIdProperty() { return CustomersRow.idProperty; }
        protected getLocalTextPrefix() { return CustomersRow.localTextPrefix; }
        protected getService() { return CustomersService.baseUrl; }

        protected form = new CustomersSMSForm(this.idPrefix);
        public rowids: string;

        private checkGrid: CustomersGrid;
        constructor(gridToRefresh, FormMode, rowKeys) {       
            super();

            this.form = new CustomersSMSForm(this.idPrefix);
            //debugger;
            this.rowids = rowKeys;
            this.form.RowIds.value = rowKeys;            
        }
        
        loadEntity(entity: CustomersRow) {
            super.loadEntity(entity);
            //debugger;
            this.form.RowIds.value = this.rowids;
            this.form.RowIds.getGridField().toggle(false);
        }

        protected getDialogButtons(): Serenity.DialogButton[]
        {
            return [              
                {
                    text: 'Send SMS',
                    click: () => {
                        debugger;                        
                        var id = this.form.RowIds.value;

                        CustomersService.SendSMS({
                            ids: this.form.RowIds.value,
                            status: this.form.Status.value


                        }, response => {
                            Q.notifyInfo(
                                'Inserted: ' + (response.Inserted || 0));
                            Q.notifySuccess("SMS sent Successfully");
                            this.dialogClose();
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }

        protected getDialogTitle(): string {
            return "Send Email";
        }
    }
}